import styled from "styled-components";
import { Modal } from "antd";

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    overflow: hidden;
    border-radius: 16px;
  }

  @media (max-width: 768px) {
    width: calc(100vw - 32px) !important;
    max-width: 480px;
    top: 16px;
    padding-bottom: 16px;

    .ant-modal-content {
      max-height: calc(100vh - 32px);
      overflow-y: auto;
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 520px;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: auto;
  }
`;

export const CardPreviewPanel = styled.div`
  background: linear-gradient(160deg, #0f2027 0%, #1a3a5c 35%, #1e5799 70%, #2471a3 100%);
  width: 380px;
  min-width: 380px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 24px;

  .rccs {
    margin: 0;
  }

  .rccs__card {
    box-shadow:
      0 12px 40px rgba(0, 0, 0, 0.5),
      0 4px 20px rgba(30, 87, 153, 0.3);
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
    padding: 24px 16px;
    gap: 16px;
  }

  @media (max-width: 380px) {
    .rccs {
      transform: scale(0.85);
    }
  }
`;

export const PanelOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 45%, rgba(36, 113, 163, 0.35) 0%, transparent 65%);
  pointer-events: none;
`;

export const SecurityBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;
  letter-spacing: 0.3px;
  z-index: 1;

  .anticon {
    font-size: 14px;
  }
`;

export const FormPanel = styled.div`
  flex: 1;
  background: #ffffff;
  padding: 40px;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 0;

  @media (max-width: 768px) {
    padding: 24px 20px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 16px;
  transition: all 0.2s;

  &:hover {
    background: #f0f0f0;
    color: #555;
  }
`;

export const PanelHeader = styled.div`
  margin-bottom: 24px;

  h3 {
    margin: 0 0 4px 0;
    font-size: 22px;
    font-weight: 700;
    color: #1a1a2e;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #8a8a9a;
  }
`;

export const AmountDisplay = styled.div`
  background: #eef4fb;
  border: 1px solid #d4e4f5;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span.label {
    font-size: 14px;
    color: #4a4a5a;
  }

  span.amount {
    font-size: 20px;
    font-weight: 700;
    color: #1e5799;
  }
`;

export const StyledInputWrapper = styled.div`
  .ant-input-affix-wrapper,
  .ant-input,
  .ant-select-selector {
    border-radius: 10px;
    background: #fafafa;
    border-color: #e0e0e8;
    transition: all 0.2s;

    &:hover {
      border-color: #b0c4de;
    }

    &:focus,
    &.ant-input-affix-wrapper-focused {
      background: #ffffff;
      border-color: #1e5799;
      box-shadow: 0 0 0 3px rgba(30, 87, 153, 0.1);
    }
  }

  .ant-select-focused .ant-select-selector {
    background: #ffffff;
    border-color: #1e5799 !important;
    box-shadow: 0 0 0 3px rgba(30, 87, 153, 0.1);
  }
`;

export const CardFormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const CardFormRow = styled.div`
  display: flex;
  gap: 16px;

  & > div {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: 380px) {
    flex-wrap: wrap;
  }
`;

export const CardFormLabel = styled.label`
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 13px;
  color: #4a4a5a;
`;

export const FieldError = styled.span`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 2px;
  display: block;
`;

export const AlertsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto;
  padding-top: 24px;

  .pay-btn {
    min-width: 180px;
    background: linear-gradient(135deg, #1e5799 0%, #2471a3 100%);
    border: none;
    border-radius: 10px;
    font-weight: 600;

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, #174a85 0%, #1d6290 100%);
    }
  }

  .cancel-btn {
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    flex-direction: column-reverse;

    .pay-btn,
    .cancel-btn {
      width: 100%;
      min-width: 0;
    }
  }
`;
